import { DatePicker } from '@bambi/component-library/src/components/inputs/DatePicker/DatePicker';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

import { useAppDispatch } from 'src/app/store/hooks';

interface DatePickerColumnFilterProps {
  open: boolean;
  onClose: () => void;
  setSelectedAction: ActionCreatorWithPayload<string | undefined, string>;
}

/**
 * This is a generic date column filter that can be used in any datagrid column.
 */
export function DatePickerColumnFilter({
  open,
  onClose,
  setSelectedAction,
}: DatePickerColumnFilterProps) {
  const dispatch = useAppDispatch();

  return (
    <DatePicker
      open={open}
      triggerElement={<div />}
      onChange={(date) => {
        dispatch(setSelectedAction(date?.toISO()));
      }}
      onClose={onClose}
    />
  );
}
